import { useEffect } from "react";

interface SEOProps {
  title: string;
  description?: string;
  keywords?: string;
  canonical?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogType?: string;
  ogUrl?: string;
  twitterCard?: string;
}

export default function SEO({
  title,
  description,
  keywords,
  canonical,
  ogTitle,
  ogDescription,
  ogType = "website",
  ogUrl,
  twitterCard = "summary_large_image",
}: SEOProps) {
  useEffect(() => {
    document.title = title;

    const setMeta = (name: string, content: string, attrName = "name") => {
      let el = document.querySelector(`meta[${attrName}="${name}"]`) as HTMLMetaElement | null;
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute(attrName, name);
        document.head.appendChild(el);
      }
      el.setAttribute("content", content);
    };

    if (description) setMeta("description", description);
    if (keywords) setMeta("keywords", keywords);

    if (ogTitle) setMeta("og:title", ogTitle, "property");
    if (ogDescription) setMeta("og:description", ogDescription, "property");
    if (ogType) setMeta("og:type", ogType, "property");
    if (ogUrl) setMeta("og:url", ogUrl, "property");

    if (title) {
      setMeta("twitter:title", title);
      if (twitterCard) setMeta("twitter:card", twitterCard, "name");
    }
    if (ogDescription) setMeta("twitter:description", ogDescription);
    if (twitterCard) setMeta("twitter:card", twitterCard);
  }, [title, description, keywords, canonical, ogTitle, ogDescription, ogType, ogUrl, twitterCard]);

  useEffect(() => {
    if (canonical) {
      let link = document.querySelector('link[rel="canonical"]') as HTMLLinkElement | null;
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonical);
    }
  }, [canonical]);

  return null;
}